module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/mapaKriminatlity-df1b4845114187687df5203fd2006929.png";